(function () {
  const form = document.getElementById("product-form");
  if (!form) return;

  const variantInput = document.getElementById("product-variant-id");
  const qtyInput = document.getElementById("product-qty-input");
  const qtyDisplay = document.querySelector(".product__qty span");
  const addBtn = document.getElementById("p-add");
  const mainImg = document.getElementById("gallery-main-img");

  // Gallery thumbnails
  document.querySelectorAll(".product__gallery-thumbs img").forEach((thumb) => {
    thumb.addEventListener("click", () => {
      document.querySelectorAll(".product__gallery-thumbs img").forEach((t) => t.classList.remove("is-active"));
      thumb.classList.add("is-active");
      mainImg.src = thumb.src;
    });
  });

  // Color chips: fill each with a plausible color from its label
  const COLOR_HEX = {
    "Noir": "#161511", "Black": "#161511",
    "Clair": "#ede8dd", "Blanc": "#f5f3ee", "White": "#f5f3ee",
    "Gris": "#9c9791", "Grey": "#9c9791", "Gray": "#9c9791",
    "Beige": "#c9ad87",
    "Marine": "#1f2c42", "Navy": "#1f2c42",
    "Vert": "#2e5b3e", "Green": "#2e5b3e",
    "Bleu": "#4fb8d9", "Blue": "#4fb8d9"
  };
  document.querySelectorAll(".product__swatch-chip[data-color]").forEach((chip) => {
    chip.style.background = COLOR_HEX[chip.dataset.color] || "#ccc";
  });

  // Option selection -> find matching variant via product JSON
  let productData = null;
  try {
    const scriptTag = document.getElementById("product-json");
    if (scriptTag) productData = JSON.parse(scriptTag.textContent);
  } catch (e) {}

  // Local per-color gallery override (currently only the Veloria watch)
  let localColorImages = null;
  try {
    const colorTag = document.getElementById("local-color-images");
    if (colorTag) localColorImages = JSON.parse(colorTag.textContent);
  } catch (e) {}

  const selected = {};
  document.querySelectorAll(".product__option").forEach((group, i) => {
    const firstSelected = group.querySelector(".is-selected");
    if (firstSelected) selected[i] = firstSelected.dataset.value;
  });

  if (localColorImages) {
    const firstColorValue = Object.values(selected)[0];
    if (firstColorValue && localColorImages[firstColorValue]) {
      mainImg.src = localColorImages[firstColorValue];
    }
  }

  // Sizes: struck through when combined with the currently selected color
  // (or other options) it would be a sold-out variant. Colors: struck through
  // only once every size in that color is sold out — not tied to whichever
  // size happens to be selected right now.
  function updateSwatchAvailability() {
    if (!productData) return;
    document.querySelectorAll(".product__swatches button").forEach((btn) => {
      const idx = btn.dataset.optionIndex;
      let unavailable;
      if (btn.classList.contains("product__swatch--color")) {
        const anyAvailable = productData.variants.some(
          (v) => [v.option1, v.option2, v.option3][idx] === btn.dataset.value && v.available
        );
        unavailable = !anyAvailable;
      } else {
        const testSelected = Object.assign({}, selected);
        testSelected[idx] = btn.dataset.value;
        const match = productData.variants.find((v) =>
          [v.option1, v.option2, v.option3].every((opt, i) => testSelected[i] == null || opt === testSelected[i])
        );
        unavailable = !!match && !match.available;
      }
      btn.classList.toggle("is-unavailable", unavailable);
    });
  }
  updateSwatchAvailability();

  document.querySelectorAll(".product__swatches").forEach((group) => {
    group.addEventListener("click", (e) => {
      const btn = e.target.closest("button");
      if (!btn) return;
      group.querySelectorAll("button").forEach((b) => {
        b.classList.remove("is-selected");
        b.setAttribute("aria-checked", "false");
      });
      btn.classList.add("is-selected");
      btn.setAttribute("aria-checked", "true");
      selected[btn.dataset.optionIndex] = btn.dataset.value;

      if (localColorImages && localColorImages[btn.dataset.value]) {
        mainImg.src = localColorImages[btn.dataset.value];
      }

      if (productData) {
        const match = productData.variants.find((v) =>
          [v.option1, v.option2, v.option3].every((opt, i) => selected[i] == null || opt === selected[i])
        );
        if (match) {
          variantInput.value = match.id;
          const hasLocalColor = localColorImages && localColorImages[btn.dataset.value];
          if (!hasLocalColor && match.featured_image) mainImg.src = match.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, "_1200x$1$2");
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? "Ajouter au panier" : "Épuisé";
        }
      }

      updateSwatchAvailability();
    });
  });

  // Quantity stepper
  document.querySelectorAll(".product__qty button").forEach((btn) => {
    btn.addEventListener("click", () => {
      let qty = parseInt(qtyDisplay.textContent, 10);
      qty = btn.textContent === "+" ? qty + 1 : Math.max(1, qty - 1);
      qtyDisplay.textContent = qty;
      qtyInput.value = qty;
    });
  });

  // Submit via Shopify AJAX cart
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    if (addBtn.disabled) return;
    const original = addBtn.textContent;
    addBtn.textContent = "Ajout en cours…";
    addBtn.disabled = true;
    window.PurityCart.add(new FormData(form))
      .then(() => {
        addBtn.textContent = "Ajouté ✓";
        setTimeout(() => {
          addBtn.textContent = original;
          addBtn.disabled = false;
        }, 1800);
      })
      .catch(() => {
        addBtn.textContent = "Erreur — réessaie";
        addBtn.disabled = false;
      });
  });
})();
